module.exports = __webpack_public_path__ + "static/media/polygone.df74399f.svg";